import { createTheme } from "@mui/material/styles";

export enum ThemeMode {
  Light = 'light',
  Dark = 'dark',
}

export const getTheme = (mode: ThemeMode = ThemeMode.Light, primaryColor: string = '#1976d2') => {
  return createTheme({
    palette: {
     
      mode: mode,
      ...(mode === ThemeMode.Light
        ? {
          text: {
            primary: '#424242',
          },
        }
      : {
          text: {
            primary: '#ffffff',
          },
        }),
        primary: {
          main: primaryColor,
        },
  },
    typography: {
      fontFamily: [
        '"Roboto"',
        'Open Sans',
        '"Helvetica"',
        '"Arial Rounded MT Bold"',
        'sans-serif'
      ].join(','),
      h6: {
        fontSize: 20,
      },
      caption: {
        fontSize: 16,
      },
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            fontSize: '16px',
            textTransform: 'none'
          },
        },
      },
      MuiFab: {
        styleOverrides: {
          root: {
            fontSize: '16px',
            textTransform: 'none'
          },
        },
      },
      MuiTooltip: {
        styleOverrides: {
          tooltip: {
            fontSize: '1em',
          },
        },
      },
    },
  });
};
